import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export function UnenrollModal({
  onConfirm,
  onReject
}) {
  return /*#__PURE__*/_jsx(ConfirmModal, {
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "sequencesCrmLib.modals.unenroll.message"
    }),
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "sequencesCrmLib.modals.unenroll.confirmLabel"
    }),
    confirmButtonProps: {
      'data-test-id': 'unenroll-confirm-button'
    },
    onConfirm: onConfirm,
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "sequencesCrmLib.modals.unenroll.rejectLabel"
    }),
    onReject: onReject
  });
}